import Vue from "vue";
import App from "./App.vue";
import Error from "./Error.vue";
import router from "./router";
import store from "./store";
import dataV from "@jiaminghi/data-view";
import axios from "axios";
import VueRouter from "vue-router";
// 引入vue-awesome
import Icon from "vue-awesome/components/Icon";
import "vue-awesome/icons/index.js";
// 调用3d图表：
import highcharts from "highcharts";
import highcharts3d from "highcharts/highcharts-3d";
// 引入轮播组件
import VueAwesomeSwiper from "vue-awesome-swiper";
// 适配flex
import "@/common/flexible.js";
// 各区域地图数据
import mapJson from "@/common/mapJson.js";
// 引入全局css
import "./assets/scss/style.scss";
// 引入Element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

Vue.use(VueRouter);
Vue.use(dataV);
Vue.component("icon", Icon);
Vue.use(VueAwesomeSwiper);
Vue.prototype.Map = mapJson;
Vue.config.productionTip = false;
highcharts3d(highcharts);

//根据router的路由模式选择服务器端地址，hash用在线上模式，history用在本地调试模式
let baseURL = "";
if (router.mode == 'hash') {
	baseURL = window.location.origin + "/otessWd";
} else {
	baseURL = "http://localhost:8080/otessWd";
}
Vue.prototype.$baseURL = baseURL;
Vue.prototype.$http = axios.create({
	timeout: 20000,	//设置20秒超时时间
	baseURL: baseURL, //这里写后端地址
});

//判断如果是“/school”学校大屏，则校验访问来源，如果不是则不校验访问来源
var storage = window.localStorage;
if (window.location.href.indexOf("/school") == -1) {
	//根据地区id获取orgCode
	var region = storage.getItem("region");
	if (region != 'false') {
		Vue.prototype.$http.get("/dataView/getOrgCodeByRedion?regionId=" + region).then(res => {
			if (res.data.code === 200) {
				var orgCode = res.data.result;
				if (orgCode != '' && orgCode != undefined) {
					storage.setItem('orgCode', orgCode);
				} else {
					storage.setItem('orgCode', 'false');
				}
			}
			//初始化vue页面
			new Vue({
				router,
				store,
				render: (h) => h(App),
			}).$mount("#app");
		});
	} else {
		storage.setItem('orgCode', 'false');
		//初始化vue页面
		new Vue({
			router,
			store,
			render: (h) => h(App),
		}).$mount("#app");
	}
} else {
	var orgId = storage.getItem("orgId");
	//根据连接中是否携带参数orgId，判断是后台访问还是终端访问，后台访问校验时间戳签名，终端不校验
	if (orgId != 'false') {
		//校验时间戳是否在有效期内，每30分钟刷新一次，如果时间戳过期则连接失效跳转错误页面
		var sign = storage.getItem("sign");
		var signTemp = new Date().getTime();
		if (sign != 'false' && orgId != 'false' && (signTemp - sign) <= 1800000) {
			storage.setItem('source', "window");
			Vue.prototype.$http.get("/dataView/getSchoolInfoByOrg?orgId=" + orgId).then(res => {
				if (res.data.code === 200) {
					storage.setItem('orgCode', res.data.school.orgCode);
					storage.setItem('schoolName', res.data.school.orgName);
				}
				//初始化vue页面
				new Vue({
					router,
					store,
					render: (h) => h(App),
				}).$mount("#app");
			});
		} else {
			new Vue({
				render: (h) => h(Error)
			}).$mount("#app");
		}
		//30分钟刷新
		setInterval(() => {
			location.reload();
		}, 1000 * 60 * 30);
	} else {
		var orgCode = storage.getItem("orgCode");
		storage.setItem('source', "android");
		Vue.prototype.$http.get("/dataView/getSchoolInfoByOrgCode?orgCode=" + orgCode).then(res => {
			if (res.data.code === 200) {
				storage.setItem('orgId', res.data.school.orgId);
				storage.setItem('schoolName', res.data.school.orgName);
			}
			//初始化vue页面
			new Vue({
				router,
				store,
				render: (h) => h(App),
			}).$mount("#app");
		});
	}
}



